import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Nav, NavDropdown, MenuItem, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { withTranslation } from 'react-i18next';
import Popup from '../horizontalMenuPopup';
import TimeZoneSettings from '../../timeZones/TimeZoneSettings';
import ReleaseNotes from '../releaseNotes/List';
import LanguageMenu from '../../../languages/LanguageMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

class HorizontalMenu extends Component {
	constructor(props) {
		super(props);
		this.handleSettingsToggle = this.handleSettingsToggle.bind(this);
		this.hideSettings = this.hideSettings.bind(this);
		this.handleReleaseNotesToggle = this.handleReleaseNotesToggle.bind(this);
		this.hideReleaseNotes = this.hideReleaseNotes.bind(this);
		this.state = {
			showSettings: false,
			showReleaseNotes: false
		};
	}

	handleSettingsToggle() {
		this.setState({ showSettings: !this.state.showSettings });
	}

	handleReleaseNotesToggle() {
		this.setState({ showReleaseNotes: !this.state.showReleaseNotes });
	}

	hideSettings() {
		this.setState({ showSettings: false });
	}

	hideReleaseNotes() {
		this.setState({ showReleaseNotes: false });
	}

	render() {
		const { currentUser, onLogout, releaseNotes, languages, t } = this.props;

		const popupTitleStyle = {
			color: '#999',
			fontSize: '11px',
			margin: '15px 10px 10px',
			textTransform: 'uppercase'
		};

		const hasNewReleaseNotes = releaseNotes.length > 0 && releaseNotes.some(x => x.status === 'new');

		return (
			<Nav pullRight>
				<NavItem ref={button => {
					this.releaseNotesToggle = button;
				}}
					onClick={this.handleReleaseNotesToggle}>
					<span style={{ fontSize: '0.6em' }}>
						<FontAwesomeIcon icon={faBell} size='2x' />
						{hasNewReleaseNotes && <FontAwesomeIcon icon={faCircle} style={{ color: '#d9534f', verticalAlign: 'top', marginLeft: '-10px', marginTop: '5px' }} />}
					</span>
				</NavItem>
				<Popup
					show={this.state.showReleaseNotes}
					onHide={this.hideReleaseNotes}
					target={this.releaseNotesToggle}
				>
					<div style={popupTitleStyle}>{t('AdminPanel_ReleaseNotes_Title')}</div>
					<div className='release-notes'>
						<ReleaseNotes releaseNotes={releaseNotes} />
					</div>
				</Popup>
				{languages.length > 1 && <LanguageMenu languages={languages} />}

				<NavDropdown id='dropdown-current-user' title={currentUser.screenName}>
					<LinkContainer to='/profile'><MenuItem><i className='clip-user-2' />&nbsp;{t('User_Profile')}</MenuItem></LinkContainer>
					<MenuItem onSelect={onLogout}><i className='clip-exit' />&nbsp;{t('Login_Logout')}</MenuItem>
				</NavDropdown>
				<NavItem ref={button => {
					this.settingsToggle = button;
				}}
					onClick={this.handleSettingsToggle}>
					<i className='clip-settings' />
				</NavItem>
				<Popup
					show={this.state.showSettings}
					onHide={this.hideSettings}
					target={this.settingsToggle}
				>
					<div style={popupTitleStyle}>{t('AdminPanelSettings_TimeZone_Title')}</div>
					<div style={{ padding: '10px' }}>
						<TimeZoneSettings />
					</div>
				</Popup>
			</Nav >
		);
	}
}

export default withRouter(withTranslation()(HorizontalMenu));